// src/components/dashboard/RecentActivity.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { formatDate, formatCurrency } from '../../utils/formatters';

const RecentActivity = ({ projects, expenses }) => {
    const activities = [
        ...projects.map(p => ({
            id: p.id,
            type: 'project',
            title: `Nuovo progetto: ${p.name}`,
            date: p.createdAt,
            link: `/projects/${p.id}`,
            icon: '🏗️',
            color: 'blue'
        })),
        ...expenses.map(e => ({
            id: e.id,
            type: 'expense',
            title: `Nuova spesa: ${formatCurrency(e.totalAmount, 'GNF')}`,
            description: e.description,
            date: e.createdAt,
            link: `/expenses/${e.id}`,
            icon: '💰',
            color: 'green'
        }))
    ].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 5);

    return (
        <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-semibold">Attività Recenti</h3>
                <Link to="/activities" className="text-blue-600 text-sm hover:underline">
                    Vedi tutte
                </Link>
            </div>

            <div className="space-y-4">
                {activities.map((activity) => (
                    <Link
                        key={activity.id}
                        to={activity.link}
                        className="flex items-start space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                        <div className={`w-10 h-10 rounded-full bg-${activity.color}-50 flex items-center justify-center`}>
                            <span className="text-lg">{activity.icon}</span>
                        </div>
                        <div className="flex-1">
                            <p className="font-medium text-gray-900">{activity.title}</p>
                            {activity.description && (
                                <p className="text-sm text-gray-500">{activity.description}</p>
                            )}
                            <p className="text-xs text-gray-400 mt-1">{formatDate(activity.date)}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default RecentActivity;